import React from "react";

import { Modal } from "@mui/material";

import { Content } from "./Content";

interface IProps {
  dealId: number | null;
  onClose: () => void;
}
// same as design like RoundsManageModal, but with different update data logic
export const RoundsManagementModal: React.FC<IProps> = ({ dealId, onClose }) => {
  if (!dealId) return null;
  return (
    <Modal open={Boolean(dealId)}>
      <Content dealId={dealId} onClose={onClose} />
    </Modal>
  );
};
